import { candidateSystemCheck, tokenForUserMobileLogin } from "../apiFunction";
import axios from "axios";
import { mapGetters } from "vuex";
import { onSave } from "../mixins/LoginFromCand";
import LoginModals from "../components/modals/LoginToastModals";
import SpeedTest from "@cloudflare/speedtest";

const SPEEDTEST_UPLOAD_URL =
	process.env.VUE_APP_SPEEDTEST_UPLOAD_URL ||
	"https://awsmultipart.hire3x.com/speed/upload/";
const SPEEDTEST_DOWNLOAD_URL =
	process.env.VUE_APP_SPEEDTEST_DOWNLOAD_URL ||
	"https://awsmultipart.hire3x.com/speed/download";

const SPEEDTEST_DURATION_MS = 10000;
const SPEEDTEST_WARMUP_MS = 2000;
const SPEEDTEST_TIMEOUT_MS = 30000;
const SPEEDTEST_CONNECTIONS = 4;
const SPEEDTEST_UPLOAD_CHUNK_BYTES = 1024 * 1024;
const SPEEDTEST_PROVIDER =
	process.env.VUE_APP_SPEEDTEST_PROVIDER || "cloudflare";
const SPEEDTEST_CF_TIMEOUT_MS = 30000;

function fillRandom(buffer) {
	for (let offset = 0; offset < buffer.length; offset += 65536) {
		crypto.getRandomValues(
			buffer.subarray(offset, Math.min(offset + 65536, buffer.length))
		);
	}
	return buffer;
}

let internet = {
	data() {
		return {
			AllowedMobAndLap: true,
			property: "value",
			angleValue: 45,
			randomInterval: null,
			downloadFetched: false,
			uploadFetched: false,
			bothFetched: false,
			downloadSpeed: 0,
			speed: 0,
			uploadSpeed: 0,
			checkupfinish: false,
			analyzeUpload: null,
			analyzedownload: null,
		};
	},
	components: {
		LoginModals,
	},
	props: {
		value: Number, // Progress value between 0 and 100
	},
	async mounted() {
		localStorage.clear();
		this.randomInterval = setInterval(() => {
			this.randomizeAngle();
		}, 500);
		try {
			await this.runSpeedTests();
		} catch (error) {
			console.warn("Speed tests encountered an error or were aborted.", error);
		} finally {
			this.bothFetched = true;
			this.checkupfinish = true;
			clearInterval(this.randomInterval);
		}
	},

	computed: {
		...mapGetters("sectionVUEX", {
			uuid: "getUUID",
			systemCheckStatus: "getSystemCheck",
			internetCheckStatus: "getInternetCheck",
		}),
		speedToDegree() {
			return Math.round(this.downloadSpeed * 1.8) - 45;
		},
		progressBarStyle() {
			return {
				background: `conic-gradient(
            #4c78ce ${10 * 3.6}deg,
            #fff ${10 * 3.6}deg
          )`,
			};
		},
		isNetSpeed() {
			return this.downloadSpeed >= 8 && this.uploadSpeed >= 3;
		},
		rotation() {
			return this.value * 3.6; // Convert percentage to degrees (1% = 3.6deg)
		},
	},

	methods: {
		async getdata() {
			const res = await tokenForUserMobileLogin();
			if (res.status == 200) {
				localStorage.setItem("vue_token", res.data.token);
				localStorage.setItem("uuid", res.data.userid);
				this.getMobileVerification();
			}
		},
		async getMobileVerification() {
			try {
				let res = await candidateSystemCheck(`?uuid=${this.$route.query.uuid}`);
				console.log(res.data.data.Detail);
				this.AllowedMobAndLap = true;
			} catch (error) {
				this.AllowedMobAndLap = false;
			}
		},
		async runSpeedTest(transferOnce, label) {
			const startTime = performance.now();
			let totalBytes = 0; // everything, for the slow-link fallback
			let measuredBytes = 0; // post-warm-up only
			let measureStart = null;
			let measureEnd = null;
			let completed = 0;
			let failed = 0;

			const controller = new AbortController();
			const timeoutId = setTimeout(() => {
				controller.abort();
				console.warn(`${label} test aborted due to timeout.`);
			}, SPEEDTEST_TIMEOUT_MS);

			const worker = async () => {
				while (performance.now() - startTime < SPEEDTEST_DURATION_MS) {
					const chunkStart = performance.now();
					let bytes;
					try {
						bytes = await transferOnce(controller.signal);
					} catch (error) {
						if (axios.isCancel(error) || error.name === "CanceledError") {
							break; // real abort (timeout) — stop this worker
						}
						failed++;
						await new Promise((r) => setTimeout(r, 50));
						continue;
					}
					completed++;
					totalBytes += bytes;
					if (chunkStart - startTime >= SPEEDTEST_WARMUP_MS) {
						if (measureStart === null || chunkStart < measureStart) {
							measureStart = chunkStart;
						}
						measuredBytes += bytes;
						measureEnd = performance.now();
					}
				}
			};

			await Promise.all(
				Array(SPEEDTEST_CONNECTIONS).fill(null).map(worker)
			);
			clearTimeout(timeoutId);

			if (failed > 0) {
				console.warn(`${label}: ${failed} request(s) failed of ${completed + failed}.`);
			}

			if (measureStart !== null && measureEnd > measureStart) {
				const seconds = (measureEnd - measureStart) / 1000;
				return (measuredBytes * 8) / seconds / (1024 * 1024);
			}
			const seconds = (performance.now() - startTime) / 1000;
			return seconds > 0 ? (totalBytes * 8) / seconds / (1024 * 1024) : 0;
		},

		async checkDownloadSpeed() {
			const fileUrl = SPEEDTEST_DOWNLOAD_URL;
			const mbps = await this.runSpeedTest(async (signal) => {
				const response = await axios.get(fileUrl, {
					responseType: "arraybuffer",
					signal,
					headers: { "Cache-Control": "no-cache" },
				});
				return response.data.byteLength;
			}, "Download");

			this.downloadSpeed = Math.round(mbps);
			this.downloadFetched = true;
		},

		next() {
			localStorage.clear();
			if (this.systemCheckStatus) {
				this.$router.push({
					name: "SystemCheck",
					query: {
						uuid: this.$route.query.uuid,
						from: this.$route.query.from,
					},
				});
			} else {
				//uncomment when query comes
				if (
					this.checkAccessTokenCookie() &&
					this.$route.query.from == "candidate"
				) {
					onSave(
						this.checkAccessTokenCookie(),
						this.$route.query.uuid,
						this.$router
					);
				}
				else {
					this.$router.push({
						name: "StudentLogin",
						query: {
							uuid: this.$route.query.uuid,
						},
					});
				}
			}
		},
		checkAccessTokenCookie() {
			const cookies = document.cookie.split("; ");
			for (let i = 0; i < cookies.length; i++) {
				const cookiePair = cookies[i].split("=");
				if (cookiePair[0] === "accessToken") {
					return cookiePair[1];
				}
			}
			return false;
		},
		async resetAllValues() {
			this.downloadFetched = false;
			this.uploadFetched = false;
			this.downloadFetched = false;
			this.bothFetched = false;
			this.downloadSpeed = 0;
			this.uploadSpeed = 0;
			this.randomInterval = setInterval(() => {
				this.randomizeAngle();
			}, 2000);
			try {
				await this.runSpeedTests();
			} catch (error) {
				console.warn(
					"Speed tests encountered an error or were aborted.",
					error
				);
			}
			this.bothFetched = true;
			this.checkupfinish = true;
			clearInterval(this.randomInterval);
		},
		randomizeAngle() {
			this.angleValue = Math.floor(Math.random() * 201) - 100;
		},
		async runSpeedTests() {
			const provider =
				(this.$route && this.$route.query && this.$route.query.provider) ||
				SPEEDTEST_PROVIDER;
			if (provider === "custom") {
				await this.runCustomTest();
				return;
			}
			// Cloudflare edge test (default), with a fail-open fallback.
			const ok = await this.checkSpeedCloudflare();
			if (!ok) {
				console.warn(
					"Cloudflare speed test unavailable; falling back to the in-house test."
				);
				this.downloadFetched = false;
				this.uploadFetched = false;
				await this.runCustomTest();
			}
		},

		async runCustomTest() {
			await this.checkDownloadSpeed();
			await this.checkUploadSpeed();
		},

		async checkSpeedCloudflare() {
			return await new Promise((resolve) => {
				let settled = false;
				let timer = null;
				const finish = (success) => {
					if (settled) return;
					settled = true;
					if (timer) clearTimeout(timer);
					resolve(success);
				};

				const engine = new SpeedTest({
					autoStart: false,
					logAimApiUrl: null,
					measurements: [
						{ type: "latency", numPackets: 1 },
						{ type: "download", bytes: 1e5, count: 1, bypassMinDuration: true },
						{ type: "download", bytes: 5e5, count: 3 },
						{ type: "download", bytes: 1e6, count: 4 },
						{ type: "upload", bytes: 1e5, count: 2, bypassMinDuration: true },
						{ type: "upload", bytes: 5e5, count: 3 },
						{ type: "upload", bytes: 1e6, count: 4 },
					],
				});

				const applySummary = () => {
					const s = engine.results.getSummary();
					if (typeof s.download === "number") {
						this.downloadSpeed = Math.round(s.download / 1e6);
						this.downloadFetched = true;
					}
					if (typeof s.upload === "number") {
						this.uploadSpeed = (s.upload / 1e6).toFixed(2);
						this.uploadFetched = true;
					}
				};

				engine.onResultsChange = () => applySummary();
				engine.onFinish = () => {
					applySummary();
					const s = engine.results.getSummary();
					finish(
						typeof s.download === "number" && typeof s.upload === "number"
					);
				};
				engine.onError = (message) => {
					console.error("Cloudflare speed test error:", message);
					finish(false);
				};

				timer = setTimeout(() => {
					try {
						engine.pause();
					} catch (e) {
						/* ignore */
					}
					console.warn("Cloudflare speed test timed out; will fall back.");
					finish(false);
				}, SPEEDTEST_CF_TIMEOUT_MS);

				engine.play();
			});
		},
		async checkUploadSpeed() {
			const sizeInBytes = SPEEDTEST_UPLOAD_CHUNK_BYTES;
			const randomData = fillRandom(new Uint8Array(sizeInBytes));

			const mbps = await this.runSpeedTest(async (signal) => {
				const formData = new FormData();
				formData.append("file", new Blob([randomData]));
				await axios.post(SPEEDTEST_UPLOAD_URL, formData, { signal });
				return sizeInBytes;
			}, "Upload");

			this.uploadSpeed = mbps.toFixed(2);
			this.uploadFetched = true;
		},
	},
};
export default internet;
